import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnDestroy,
    OnInit
} from '@angular/core';

import { LatLngType, MapApiService, MarkerType, PopupOptionsType, PopupType } from '../services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'rwidget-map-popup',
    template: `<div class="rmap-popup"><ng-content></ng-content></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapPopupComponent implements OnInit, OnDestroy, AfterContentInit {
    private content: HTMLElement;
    private popup: PopupType;

    /**
     * Used only when you use the component outside map-marker
     */
    @Input() latitude: number;

    /**
     * Used only when you use the component outside map-marker
     */
    @Input() longitude: number;

    @Input() hasCloseButton = false;
    @Input() minWidth = 250;
    @Input() maxWidth = 300;

    @Input() set coordinates(latlng: LatLngType) {
        if (latlng) {
            this.zone.runOutsideAngular(() => this.mapApi.openPopup(latlng, this.popup));
        }
    }

    closePopup = () => this.mapApi.closePopup();

    constructor(
        private mapApi: MapApiService,
        private eRef: ElementRef,
        private zone: NgZone
    ) {}

    ngOnInit(): void {
        this.content = this.eRef.nativeElement.querySelector('.rmap-popup');
        this.zone.runOutsideAngular(() => this.content.addEventListener('click', this.closePopup));
    }

    ngAfterContentInit(): void {
        this.zone.runOutsideAngular(() => {
            const options: PopupOptionsType = {
                minWidth: this.minWidth,
                maxWidth: this.maxWidth,
                closeButton: this.hasCloseButton
            };

            this.popup = this.mapApi.createPopup(this.content, options);

            if (this.latitude && this.longitude) {
                const latlng = {
                    lat: this.latitude,
                    lng: this.longitude
                };

                this.mapApi.openPopup(latlng, this.popup);
            }
        });
    }

    ngOnDestroy(): void {
        this.zone.runOutsideAngular(() => this.content.removeEventListener('click', this.closePopup));
    }

    setHostMarker(marker: MarkerType): void {
        if (marker) {
            this.zone.runOutsideAngular(() => this.mapApi.addPopupToMarker(marker, this.popup));
        }
    }

    getPopup(): PopupType {
        return this.popup;
    }
}
